import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import WithConfirm from '../../UIComponents/withConfirm';

const useStyles = makeStyles((theme) => ({
    pass: {
        color: theme.palette.success.main,
    },
    fail: {
        color: theme.palette.error.main,
    },
    warning: {
        color: theme.palette.warning.main,
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    summaryText: {
        marginRight: theme.spacing(2),
    },
    icon: {
        marginRight: theme.spacing(1),
    }
}));

const PayrollValidationDialog = ({ open, errors, logicChecks, onClose, onConfirm, needsConfirmation, confirmTitle, confirmContent }) => {
    const classes = useStyles();
    const totalLogicChecks = logicChecks ? logicChecks.length : 0;
    const passedLogicChecks = logicChecks ? logicChecks.filter(c => c.passed).length : 0;
    const allLogicPassed = totalLogicChecks === passedLogicChecks;

    const hasSchemaErrors = errors && errors.length > 0;
    const hasLogicErrors = !allLogicPassed;
    const hasAnyErrors = hasSchemaErrors || hasLogicErrors;

    // Track expanded state for each logic check
    const [expandedIdx, setExpandedIdx] = useState(null);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <div className={classes.title}>
                    Validation Results
                    <Typography variant="h6" className={allLogicPassed ? classes.pass : classes.fail}>
                        {passedLogicChecks}/{totalLogicChecks} Rules Passed
                    </Typography>
                </div>
            </DialogTitle>
            <DialogContent dividers>
                {logicChecks && logicChecks.length > 0 && (
                    <div>
                        <Typography variant="h6">Logic Checks</Typography>
                        <Table size="small">
                           <TableBody>
                                {logicChecks.map((check, idx) => [
                                    <TableRow   style={{ cursor: 'pointer' }} key={idx} onClick={() => setExpandedIdx(expandedIdx === idx ? null : idx)} >
                                        <TableCell>
                                            {check.passed && check.type === 'info' ? <InfoIcon style={{color: '#1976d2'}} /> : check.passed ? <CheckCircleIcon className={classes.pass} /> : check.type === 'warning' ? <WarningIcon className={classes.warning} /> : <CancelIcon className={classes.fail} />}
                                        </TableCell>
                                        <TableCell>{check.name}</TableCell>
                                        <TableCell>
                                            {check.passed ? "Passed" : check.type === 'warning' ? "Warning" : `Failed. Expected ${check.expected.toFixed ? check.expected.toFixed(2) : check.expected}, but got ${check.actual.toFixed ? check.actual.toFixed(2) : check.actual}`}
                                            {check.details && check.details.length > 0 && (
                                                <Button size="small" color={check.type === 'info' ? "info" : "primary"} style={{ marginLeft: 16 }} onClick={() => setExpandedIdx(expandedIdx === idx ? null : idx)}>
                                                    {check.type === 'info' ? 'See Details' : 'Why?'} <span> Show {check.details.length } {check.type === 'info' ? 'Items' : 'Issues'}</span>
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>,
                                    (check.details && check.details.length > 0 && expandedIdx === idx) && (
                                        <TableRow key={idx + '-details'}>
                                            <TableCell colSpan={3} style={{ padding: 0, border: 0 }}>
                                                <div style={{ marginLeft: 32, borderLeft: '3px solid #eee', paddingLeft: 16, background: '#fafbfc' }}>
                                                    {check.name === 'Unprocessed Time Attendance' ? (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Name</TableCell>
                                                                    <TableCell>Mate ID</TableCell>
                                                                    <TableCell>Full Expected Hrs</TableCell>
                                                                    <TableCell>Pay Hrs</TableCell>
                                                                    <TableCell>OT</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {check.details.map((d, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell>{d.name}</TableCell>
                                                                        <TableCell>{d.mateId}</TableCell>
                                                                        <TableCell>{d.fullExpectedHrs}</TableCell>
                                                                        <TableCell>{d.payHrs}</TableCell>
                                                                        <TableCell>{d.ot ? JSON.stringify(d.ot) : ''}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    ) : check.type === 'info' || check.type === 'warning' ? (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Employee</TableCell>
                                                                    <TableCell>Remark</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {check.details.map((d, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell>{d.name}</TableCell>
                                                                        <TableCell>{d.remark}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    ) : (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Employee</TableCell>
                                                                    <TableCell>Basic Salary</TableCell>
                                                                    <TableCell>Rate</TableCell>
                                                                    <TableCell>Expected</TableCell>
                                                                    <TableCell>Actual</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {check.details.map((d, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell>{d.name}</TableCell>
                                                                        <TableCell>{d.basicSalary}</TableCell>
                                                                        <TableCell>{d.rate}</TableCell>
                                                                        <TableCell>{d.expected.toFixed ? d.expected.toFixed(2) : d.expected}</TableCell>
                                                                        <TableCell>{d.actual.toFixed ? d.actual.toFixed(2) : d.actual}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    )}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )
                                ])}
                            </TableBody>
                        </Table>
                    </div>
                )}

                {errors && errors.length > 0 && (
                    <ExpansionPanel style={{ marginTop: 20 }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Show {errors.length} Schema Validation Errors</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Field</TableCell>
                                        <TableCell>Error</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Current Value</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {errors.map((err, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell>{err.recordType === 'payroll' ? 'Payroll' : 'Payroll Run'}</TableCell>
                                            <TableCell>{err.field}</TableCell>
                                            <TableCell>{err.error}</TableCell>
                                            <TableCell>{err.name || '-'}</TableCell>
                                            <TableCell>{String(err.value)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )}

                {(!errors || errors.length === 0) && (!logicChecks || logicChecks.every(c => c.passed)) && (
                    <Typography>All validation checks passed.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                {needsConfirmation ? (
                    <>
                    <WithConfirm title={confirmTitle} content={confirmContent} onConfirm={onConfirm}>
                        <Button >
                            Continue Anyway
                        </Button>
                    </WithConfirm>
                    <Button onClick={onClose} color="default" variant='contained' autoFocus>
                    Close
                </Button>
                    </>
                ) : (
                    <>
                     <Button onClick={onClose} color="default">
                    Close
                </Button>
                    <Button onClick={onConfirm} color="primary" variant='contained' autoFocus>
                        Save & Continue
                    </Button>
                    </>
                )}
               
            </DialogActions>
        </Dialog>
    );
};

export default PayrollValidationDialog; 